export default function ReportInstanceStatusDirective() {
  return {
    template: require('./report-instance-status.html'),
    scope: {
      reportInstanceStatus: '=',
    },
    controller: 'GRReportInstanceStatusController',
    controllerAs: 'grReportInstanceStatusVM',
    bindToController: true,
    replace: true
  };
}
